import { IPartner } from "../../../domain/IPartner";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import { useSelector } from "react-redux";
import { selectState, setSelectedIndexById } from "../main.slice";
import DeletePartnerModal from "./DeletePartnerModal";
import Loader from "components/Loader/Loader";
import IncidentsPopover from "./IncidentsPopover";
import { useLocation } from "react-router-dom";
import { INavigationStatePartner } from "authentication/domain/INavigationState";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useWindowedRows } from "hooks/useWindowedRows";

// Keep in sync with `.g-grid.g-content .row` height ($grid-content-row-height).
const ROW_HEIGHT = 20;

export const PartnersList = () => {
  const location = useLocation();
  const state = location.state as INavigationStatePartner | undefined;
  const dispatch = useAppDispatch();
  const { partners, loading } = useSelector(selectState);

  const partnersList = state?.partnerId
    ? partners.filter((p) => p.partnerId === state.partnerId)
    : partners;

  const { contentRef, startIndex, endIndex, topSpacer, bottomSpacer } =
    useWindowedRows({
      count: partnersList.length,
      rowHeight: ROW_HEIGHT,
      overscanPx: 100 * ROW_HEIGHT,
    });

  useEffect(() => {
    if (partnersList.length > 0 && state) {
      dispatch(setSelectedIndexById(state.partnerId));
    }
  }, [dispatch, state, partnersList]);

  return (
    <div className="partners-list loading-container">
      {loading && <Loader />}
      <TableHeader count={partnersList.length} />
      <div className="g-grid g-content" ref={contentRef}>
        {topSpacer > 0 && <div style={{ height: topSpacer }} />}
        {partnersList
          .slice(startIndex, endIndex)
          .map((item: IPartner, offset: number) => {
            const index = startIndex + offset;
            return <TableRow item={item} index={index} key={index} />;
          })}
        {bottomSpacer > 0 && <div style={{ height: bottomSpacer }} />}
      </div>
      <DeletePartnerModal />
      <IncidentsPopover />
    </div>
  );
};
